<template>
  <div>
    <div class="h-20 flex items-center" v-if="loading">
      <loading />
    </div>
    <div v-else>
      <div
        class="w-full mt-20 p-8 stack text-center"
        v-if="!activities || activities.length < 1 || !activityCategories"
      >
        <div>
          <icon
            name="WaldigLogo"
            size="3.5em"
            :settings="{ strokeWidth: 0.8 }"
          />
        </div>
        <div class>{{ $t("activities.no_activities") }}</div>
        <info class="mt-4" toggleable :title="$t('activities.add_activities')">
          {{ $t("activities.add_activities_message") }}
        </info>
      </div>
      <div class="stack" v-else>
        <div class="p-2">
          <wd-filter
            :filters="filters"
            :input-array="activities"
            @update="filteredActivities = $event"
          />
        </div>
        <activity
          swipeable
          v-for="activity in filteredActivities"
          :key="activity.id"
          :category="getCategory(activity.activity_category_id)"
          :activity="activity"
          @removed="reload"
        />
      </div>
      <load-more-section show-count name="activity" @input="getActivities" />
    </div>
    <fab @input="openCreateActivity">
      <icon name="Plus" />
    </fab>
  </div>
</template>

<script>
const Activity = require("@/modules/activities/components/Activity.vue")
  .default;
const WdFilter = require("@/modules/core/components/WdFilter.vue").default;
const Fab = require("@/modules/core/components/Fab.vue").default;
const Loading = require("@/modules/core/components/Loading.vue").default;
const Info = require("@/modules/core/components/Info.vue").default;
const LoadMoreSection = require("@/modules/core/components/LoadMoreSection.vue")
  .default;

import { Activity as ActivityModel } from "../viewmodels/Activity";
import { ActivityCategory } from "../viewmodels/ActivityCategory";
import { UserActivity } from "@/modules/users/viewmodels/UserActivity";

export default {
  name: "ActivitiesSite",
  data() {
    return {
      activities: null,
      filteredActivities: [],
      activityCategories: [],
      helpVisible: false,
      filters: [],
      initialFilterValues: null,
    };
  },
  props: {},
  components: {
    Activity,
    Fab,
    Loading,
    Info,
    WdFilter,
    LoadMoreSection,
  },
  methods: {
    openCreateActivity() {
      this.$router.push("/create-activity");
    },
    getCategory(Id) {
      return this.activityCategories
        ? new ActivityCategory(this.activityCategories.find((e) => e.id === Id))
        : false;
    },
    updateFilter(FilterObj) {
      this.filters = FilterObj;
    },
    async getActivities() {
      this.activities = await this.getEntity("activity");
    },
    reload(){
      location.reload();
    }
  },
  computed: {
    active() {
      return { "transform: translateX(10)": true };
    },
    // filteredActivities() {
    //   let elements = this.activities;

    //   if (
    //     this.filters.activity_category_id &&
    //     this.filters.activity_category_id !== "all"
    //   ) {
    //     elements = elements.filter(
    //       (e) => e.activity_category_id === this.filters.activity_category_id
    //     );
    //   }

    //   if (this.filters.title) {
    //     elements = elements.filter((e) =>
    //       e.title.toUpperCase().includes(this.filters.title.toUpperCase())
    //     );
    //   }

    //   return elements;
    // },
  },
  async created() {
    this.activityCategories = await this.$store.getters[
      "activitycategory/api"
    ].GetAll();
    await this.getActivities();

    this.filters.push(
      {
        name: this.$t("general.title"),
        key: "title",
        input: "text",
      },
      {
        name: this.$t("activities.activity_category"),
        key: "activity_category_id",
        input: "select",
        type: "equal",
        options: this.activityCategories,
        optionId: "id",
        optionLabel: "title",
      }
    );

    this.loaded();
  },
};
</script>
